import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./PeriodEditor.module.css";

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const PeriodEditor = (props) => {
    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);
    const [showRates, setShowRates] = useState(false);

    const keyDownHandler = (e) => {
        if (e.key === "Enter" && (min >= 0 || max >= 0)) {
            props.onSubmit(min, max);
        } else if (e.key === "Escape") {
            props.onClose();
        }
    };

    const handleToggleRates = () => {
        setShowRates(!showRates);
        props.setSelectedRates([]);
    };

    const handleToggleRate = (id) => {
        props.setSelectedRates((prevSelectedRates) => {
            if (prevSelectedRates.includes(id)) {
                return prevSelectedRates.filter((rateId) => rateId !== id);
            } else {
                return [...prevSelectedRates, id];
            }
        });
    };

    const handleToggleAll = () => {
        if (props?.selectedRates?.length === props.rates.length) {
            props.setSelectedRates([]);
        } else {
            props.setSelectedRates(props.rates.map((rate) => rate.id));
        }
    };

    const ratesGrid = (
        <div>
            <Button
                color="primary"
                variant="contained"
                endIcon={<ArrowBackIcon />}
                style={{ backgroundColor: grey[500] }}
                onClick={handleToggleRates}
            >
                {showRates ? "Скрыть тарифы" : "Показать тарифы"}
            </Button>
            {showRates && (
                <div className={styles.flex__rates}>
                    {props.rates.map((rate) => (
                        <div key={rate.id} className={styles.rates__elem}>
                            <label
                                htmlFor={rate.code + "__" + rate.id}
                                title={rate.name}
                            >
                                <input
                                    id={rate.code + "__" + rate.id}
                                    className={styles.period__input}
                                    type="checkbox"
                                    checked={
                                        props.selectedRates.includes(rate.id) ||
                                        rate.id == props.rateId
                                    }
                                    onChange={() => handleToggleRate(rate.id)}
                                />
                                {rate.code}
                            </label>
                        </div>
                    ))}
                    <Button
                        color="primary"
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{ backgroundColor: green[500] }}
                        onClick={handleToggleAll}
                    >
                        {props?.selectedRates?.length === props?.rates?.length
                            ? "Снять выделение"
                            : "Выделить все"}
                    </Button>
                </div>
            )}
        </div>
    );

    return (
        <div>
            <Dialog
                onKeyDown={keyDownHandler}
                open={props.isVisible}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Введите новые значения
                </DialogTitle>
                <DialogContent>
                    <TextField
                        style={{ margin: "10px" }}
                        autoFocus
                        error={min < 0}
                        helperText={
                            min < 0
                                ? "Значение не может быть отрицательным"
                                : null
                        }
                        id="standard-number"
                        label="Мин срок проживания"
                        type="number"
                        onChange={(e) => setMin(parseInt(e.target.value))}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        style={{ margin: "10px" }}
                        autoFocus
                        error={max < 0}
                        helperText={
                            max < 0
                                ? "Значение не может быть отрицательным"
                                : null
                        }
                        id="standard-number"
                        label="Макс срок проживания"
                        type="number"
                        onChange={(e) => setMax(parseInt(e.target.value))}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {ratesGrid}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={props.onClose}
                        color="primary"
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{ backgroundColor: orange[500] }}
                    >
                        Вернуться
                    </Button>

                    <Button
                        disabled={
                            (min >= 0 || max >= 0) &&
                            (min != null || max != null)
                                ? false
                                : true
                        }
                        onClick={() => props.onSubmit(min, max)}
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={
                            (min >= 0 || max >= 0) &&
                            (min != null || max != null)
                                ? { backgroundColor: green[500] }
                                : { backgroundColor: grey[500] }
                        }
                    >
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PeriodEditor;
